export default function GlobeIcon({ isDark }: { isDark: boolean }) {
  return (
    <svg
      width="41"
      height="22"
      viewBox="0 0 41 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11H21M15 11C15 12.3132 14.8965 13.6136 14.6955 14.8268C14.4945 16.0401 14.1999 17.1425 13.8284 18.0711C13.457 18.9997 13.016 19.7362 12.5307 20.2388C12.0454 20.7413 11.5253 21 11 21C10.4747 21 9.95457 20.7413 9.46927 20.2388C8.98396 19.7362 8.54301 18.9997 8.17157 18.0711C7.80014 17.1425 7.5055 16.0401 7.30448 14.8268C7.10346 13.6136 7 12.3132 7 11C7 9.68678 7.10346 8.38642 7.30448 7.17316C7.5055 5.95991 7.80014 4.85752 8.17157 3.92893C8.54301 3.00035 8.98396 2.26375 9.46927 1.7612C9.95457 1.25866 10.4747 1 11 1C11.5253 1 12.0454 1.25866 12.5307 1.76121C13.016 2.26375 13.457 3.00035 13.8284 3.92893C14.1999 4.85752 14.4945 5.95991 14.6955 7.17317C14.8965 8.38642 15 9.68678 15 11Z"
        stroke={isDark ? 'white' : '#222222'}
        strokeLinecap="round"
      />
      <path
        d="M21 11C21 12.3132 20.7413 13.6136 20.2388 14.8268C19.7362 16.0401 18.9997 17.1425 18.0711 18.0711C17.1425 18.9997 16.0401 19.7362 14.8268 20.2388C13.6136 20.7413 12.3132 21 11 21C9.68678 21 8.38642 20.7413 7.17317 20.2388C5.95991 19.7362 4.85752 18.9997 3.92893 18.0711C3.00035 17.1425 2.26375 16.0401 1.7612 14.8268C1.25866 13.6136 1 12.3132 1 11C1 9.68678 1.25866 8.38642 1.76121 7.17316C2.26375 5.95991 3.00035 4.85752 3.92893 3.92893C4.85752 3.00035 5.95991 2.26375 7.17317 1.7612C8.38642 1.25866 9.68678 1 11 1C12.3132 1 13.6136 1.25866 14.8268 1.76121C16.0401 2.26375 17.1425 3.00035 18.0711 3.92893C18.9997 4.85752 19.7362 5.95991 20.2388 7.17317C20.7413 8.38642 21 9.68678 21 11L21 11Z"
        stroke={isDark ? 'white' : '#222222'}
      />
      <path
        fill={isDark ? 'white' : '#222222'}
        d="M35.7559 14.1271C35.3572 14.5876 34.6428 14.5876 34.2441 14.1271L31.2368 10.6547C30.6759 10.007 31.136 9 31.9927 9L38.0073 9C38.864 9 39.3241 10.007 38.7632 10.6547L35.7559 14.1271Z"
        stroke={isDark ? 'white' : '#222222'}
      />
    </svg>
  );
}
